import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Paragraf } from "../Styled";

export const UdviklingsProcesUnder = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 75px;
  justify-content: space-between;
  margin: auto;
  padding: 75px 0;
  align-items: center;
  max-width: 1200px;
`;

export const UdvIkon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  display: block;
  margin: auto;
  padding: 25px;
  background-color: rgba(65, 132, 234, 0.05);
  border-radius: 50%;
  transition: all 250ms ease-out;
  color: #271a44;
`;

export const UdvKortCon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  @media screen and (max-width: 1000px) {
    row-gap: 25px;
  }
`;

export const UdvKort = styled.div`
  width: 30%;
  flex-grow: 0;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 25px;
  transition: all 250ms ease-out;
  & h2 {
    text-align: center;
    font-size: 2rem;
    font-weight: 500;
    color: #271a44;
  }
  &:hover {
    background-color: ${({ theme }) => theme.mainColors.hvid};
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
    & h2 {
      transition: all 250ms ease-out;
      color: #7136ed;
    }
    & ${UdvIkon} {
      color: ${({ theme }) => theme.mainColors.hvid};
      background: #7136ed;
      ${({ theme }) => theme.mainColors.lightblu} 100%
      );
    }
  }
  @media screen and (max-width: 1000px) {
    width: 100%;
  }
`;

export const UdvPara = styled(Paragraf)`
text-align: center;
    font-size: 1.25rem;
`